// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"AppLayout_rootContainer__1dRUE","pageContainer":"AppLayout_pageContainer__2Falj","withMenuVisible":"AppLayout_withMenuVisible__1R_TF"};